export const MODULE_ID = 'account';
export const OTP_METHODS = {
    OFF: 'Off',
    EMAIL: 'Email',
    SMS: 'SMS'
};
export const OTP_LENGTH = 6;
export const OTP_FAILED_ATTEMPTS_LIMIT = 3;
export const OTP_RESEND_LOCK = 30;
export const SCOPE_NAMES = {
    PROFESSIONAL: 'Professional',
    CLINIC_STAFF: 'ClinicStaff',
    PERSONAL: 'Personal',
    CAREGIVER: 'Caregiver'
};
export const BUSINESS_SCOPES = [
    SCOPE_NAMES.PROFESSIONAL,
    SCOPE_NAMES.CLINIC_STAFF
];
export const PRIVATE_SCOPES = [
    SCOPE_NAMES.PERSONAL,
    SCOPE_NAMES.CAREGIVER
];
export const ACCOUNT_PORTAL = {
    name: 'CONTOUR Account',
    key: 'aid',
    image: 'aid.png',
    scopes: [
        ...BUSINESS_SCOPES,
        ...PRIVATE_SCOPES
    ],
    countries: []
};
export const APPS = {
    GCO: {
        name: 'GlucoContro Online',
        key: 'gco',
        image: 'gco.png',
        scopes: [
            SCOPE_NAMES.PROFESSIONAL,
            SCOPE_NAMES.PERSONAL,
            SCOPE_NAMES.CAREGIVER
        ],
        countries: []
    },
    CDA: {
        name: 'CONTOUR™DIABETES app',
        key: 'alpine',
        image: 'cda.png',
        customWelcome: true,
        scopes: [
            SCOPE_NAMES.PERSONAL
        ],
        isHiddenInAppCatalog: true,
        countries: []
    }
};
export const OTHER_PLATFORMS = {
    CDA: {
        name: 'CONTOUR™DIABETES app',
        key: 'cda',
        image: 'cda.png',
        scopes: [
            SCOPE_NAMES.PERSONAL
        ],
        countries: [],
        url: 'https://www.ascensiadiabetes.com/products/contour-diabetes-app/'
    }
};
export const SUPPORTED_PLATFORMS = [
    'GCO',
    'CDA'
];
export const IDENTITY_PROVIDER_TYPE = {
    ContourCloud: 'ContourCloud',
    Aid: 'Aid',
    Draft: 'Draft'
};
export const IDENTITY_PROVIDER_IMAGES = {
    Aid: 'ascensia.svg',
    ContourCloud: 'cda.png'
};
export const IDENTITY_STATUSES = {
    AVAILABLE: 'Available',
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    RESET_PASSWORD: 'ResetPassword',
    DELETED: 'Deleted'
};
export const COMMUNICATION_CONSENT_TYPES = [
    'Email'
];
export const IDENTITY_PASSWORD_MODAL = `${MODULE_ID}/identityPasswordModal`;
export const GUARDIAN_CONFIRMATION_STATUS_MODAL = `${MODULE_ID}/guardianConfirmationStatusModal`;
export const ELEVATE_PERMISSIONS_FORM = `${MODULE_ID}.elevatePermissionsForm`;
export const ACCEPT_INVITATION_FORM = `${MODULE_ID}.acceptInvitationForm`;
export const INFORMATION_FORM = `${MODULE_ID}.informationForm`;
export const RESET_PASSWORD_FORM = `${MODULE_ID}.resetPasswordForm`;
export const SET_PASSWORD_FORM = `${MODULE_ID}.setPasswordForm`;
export const SIGN_IN_FORM = `${MODULE_ID}.signInForm`;
export const SIGN_UP_FORM = `${MODULE_ID}.signUpForm`;
export const IDENTITY_PASSWORD_FORM = `${MODULE_ID}.identityPasswordForm`;
export const DELETE_ACCOUNT_FORM = `${MODULE_ID}.deleteAccount`;
export const VERIFY_EMAIL_FORM = `${MODULE_ID}.verifyEmailForm`;
export const EDIT_GUARDIAN_EMAIL_FORM = `${MODULE_ID}.editGuardianEmailForm`;
export const ANONYMOUS_FIRST_NAME = 'Anonymous';
export const ANONYMOUS_LAST_NAME = 'User';
export const PASSWORD_RULES = [
    'passwordMinimum',
    'atLeastOneNumber',
    'atLeastOneUppercase',
    'atLeastSpecialCharacter'
];
